import {
  musicServicesById,
  musicServicesByImporterID,
  musicServicesByMusicAPIID,
} from 'fym-shared/src/music-services/allMusicServices';

/**
 * The service name a person recognises. The data stores an internal id: the service id
 * ("apple-music"), the MusicAPI integration id ("appleMusic", the pre-save and fan rows) or the
 * importer id. Each becomes "Apple Music". An id we do not know is shown as it is rather than
 * hidden.
 */
export function formatServiceName(key: string): string {
  return (
    musicServicesById[key]?.name ?? musicServicesByMusicAPIID[key]?.name ?? musicServicesByImporterID[key]?.name ?? key
  );
}
